import React from "react";
import facebook from "../../assets/facebook.svg";
import linkedIn from "../../assets/linked-in.svg";
import email from "../../assets/email.svg";
import twitter from "../../assets/twitter.svg";
import "../SocialsContainer.scss";

const SocialsContainer = ({ quiz }) => {

  const callAnalytics = (text) => {
    window.appEventData.push({
      event: "UI Item Clicked",
      linkInfo: {
        category: "interactive",
        text,
      },
    });
  };

  const socialClick = (e, social) => {
    // eslint-disable-next-line no-restricted-globals
    // const url = encodeURIComponent(window.location.href);
    //const url = encodeURIComponent(`https://mckinsey.com/featured-insights/data-points?cid=soc-web#quiz-${quiz.id}`)
    const url = encodeURIComponent(`${window.location.origin}${window.location.pathname}?cid=soc-web#quiz-${quiz.id}`);

    const twitterText = encodeURIComponent(
      `Hey, I got this question correct in the pop quiz I took in the #McKinsey Explainers series. Take the quiz and learn more here: `
    );

    const emailSubject = `From McKinsey.com: Pop quiz from McKinsey Explainers`;
    // eslint-disable-next-line no-restricted-globals
    const emailBody = `Hey, I got this question correct in the pop quiz I took in the #McKinsey Explainers series. Take the quiz and learn more here: %0d%0a ${url}`;

    switch (social) {
      case "twitter":
        callAnalytics(
          `${quiz.title}-call-to-twitter`
        );
        window.open(
          `https://twitter.com/intent/tweet?text=${twitterText}&url=${url}`,
          "_blank",
          "location=yes,height=570,width=570,scrollbars=yes,status=yes"
        );
        break;
      case "facebook":
        callAnalytics(
          `${quiz.title}-call-to-facebook`
        );
        window.open(
          // eslint-disable-next-line no-restricted-globals
          `https://www.facebook.com/sharer/sharer.php?u=${url}`,
          "_blank",
          "location=yes,height=570,width=570,scrollbars=yes,status=yes"
        );
        break;
      case "linkedIn":
        callAnalytics(
          `${quiz.title}-call-to-linkedin`
        );
        window.open(
          `https://www.linkedin.com/shareArticle?mini=true&url=${url}&summary=${twitterText}`,
          "_blank",
          "location=yes,height=570,width=570,scrollbars=yes,status=yes"
        );
        break;
      case "email":
        callAnalytics(
          `${quiz.title}-call-to-email`
        );
        window.open(
          // `${"mailto:" + "" + "?cc=" + "" + "&subject="
          // }${emailSubject}&body=${emailBody}`,
          // "_self"
          `mailto:${""}?subject=${emailSubject}&body=${emailBody}`
        );
        break;

      default:
        break;
    }
  };

  return (
    <div className="socials-container">
      <button
        type="button"
        className="socials-button"
        onClick={(e) => socialClick(e, "linkedIn")}
      >
        <span className="mck-linkedin-icon socials-icon" aria-label="LinkedIn icon">
       
        </span>
      </button>

      <button
        type="button"
        className="socials-button"
        onClick={(e) => socialClick(e, "twitter")}
      >
       <span className="mck-twitter-icon socials-icon" aria-label="Twitter icon">
       
       </span>
      </button>

      <button
        type="button"
        className="socials-button"
        onClick={(e) => socialClick(e, "facebook")}
      >
         <span className="mck-facebook-icon socials-icon" aria-label="Facebook icon">
         
         </span>
      </button>
      <button
        type="button"
        className="socials-button"
        onClick={(e) => socialClick(e, "email")}
      >
         <span className="mck-email-icon socials-icon">
         
         </span>
      </button>
    </div>
  );
};

export default SocialsContainer;